import { render, staticRenderFns } from "./MenuMode.vue?vue&type=template&id=896c37e0&scoped=true"
import script from "./MenuMode.vue?vue&type=script&lang=js"
export * from "./MenuMode.vue?vue&type=script&lang=js"
import style0 from "./MenuMode.vue?vue&type=style&index=0&id=896c37e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "896c37e0",
  null
  
)

export default component.exports